/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import { setPagination } from "@/utils/helpers/pagination";
import { getDefaultState } from "./state";

export default {
  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },
  SET_LIST_WITH_PAGINATION(state, data) {
    state.list = data.items || [];
    state.pagination = data.pagination || {};
  },
  SET_LIST(state, data) {
    state.list = data.items;
    if (data && data.pagination) {
      state.pagination = { ...state.pagination, ...data.pagination };
    }
  },
  SET_PAGINATION(state, data) {
    state.pagination = { ...state.pagination, ...data };
  },
  UPDATE_SUCCESS(state, data) {
    const pos = state.list
      .map(function (e) {
        return e.id;
      })
      .indexOf(data.id);
    if (data.fix_class_id === null) {
      state.list.splice(pos, 1);
      state.pagination = setPagination(state.pagination, data.id);
    } else {
      state.list.splice(pos, 1, data);
    }
  },
  REMOVE_RECORD(state, itemId) {
    if (Array.isArray(itemId)) {
      itemId.forEach((item) => {
        const index = state.list.findIndex((u) => u.id === item);
        state.list.splice(index, 1);
      });
    } else {
      const index = state.list.findIndex((u) => u.id === itemId);
      state.list.splice(index, 1);
    }

    state.pagination = setPagination(state.pagination, itemId);
  },

  SET_CLASS_HISTORIES(state, data) {
    state.class_histories = data;
  },
};
